import React from 'react';
import styles from './StanAccordionBody.module.css';
import { useCollapse } from 'react-collapsed';
import { StanAccordionBodyProps } from '../StanAccordion.types';
import { useAccordionContext, useAccordionItemContext } from '../StanAccordion.context';
import { cn } from '@/lib';

export const StanAccordionBody: React.FC<StanAccordionBodyProps> = ({ children, className = '' }) => {
    const { id } = useAccordionItemContext();
    const { isItemOpen } = useAccordionContext();
    const open = isItemOpen(id);
    const { getCollapseProps } = useCollapse({
        isExpanded: open,
        duration: 300,
        easing: 'ease-out',
    });
    return (
        <div {...getCollapseProps()}>
            <div id={`stan-accordion-body-${id}`} className={cn(styles.accordionContentInner, className)}>
                {children}
            </div>
        </div>
    );
};
